import React from "react";
import { EmbeddedAsset } from "../../../graphql-types";
import Image from "../../components/GatsbyImage";
import { IGatsbyImageData, getImage, ImageDataLike } from "gatsby-plugin-image";

type Props = {
  asset: EmbeddedAsset;
};

export function EmbeddedImage({ asset }: Props) {
  const image = getImage(
    asset?.file?.fileLocal as ImageDataLike
  ) as IGatsbyImageData;
  return <Image alt={asset.description} image={image} loading="eager" />;
}
